import { AuthService } from "@adc/utilities/auth-service";
import { AuthStatus } from "@adc/utilities/iauthstatusresponse";
import { LoginStatus } from "@adc/utilities/iloginstatus";
import axios from 'axios';
import * as data from "../../assets/footer-data.json";
import { GlobalDataController } from "../utilities/global-data-controller";
import { TranslationDataController } from '../utilities/translation-data-controller';
import type { IAuthUserResponse } from "@adc/utilities/iauthuserresponse";
import type { ITargetDetails } from "@adc/utilities/itargetDetails";
import type { ReactiveController, ReactiveControllerHost } from "lit";

export class FooterDataController implements ReactiveController {
  authService = new AuthService();
  private readonly host: ReactiveControllerHost;
  public linkData: object;
  public targetAds: object;
  targetDetails : ITargetDetails;
  protocol = document.location.protocol;
  locale = TranslationDataController.retrieveLocale();
  authStatus: AuthStatus = AuthStatus.GUEST;
  loginStatus: string = LoginStatus[0];
  memberInfo: void | IAuthUserResponse;
  aadvantageNumber = '';

  constructor(host: ReactiveControllerHost) {
    (this.host = host).addController(this);
  }

  hostConnected() {
    this.fetchData();
    this.getTarget().then(() => {
      this.host.requestUpdate();
    });
  }

  async fetchData() {
    const url = new URL(document.location.href);
    const protocol = document.location.protocol;
    
    const allowedLocalHosts = [
      'localhost',
      'ideal-succotash'
    ];

    if (allowedLocalHosts.includes(url.hostname)) {
      this.processData(data);
    } else {
      const response = await TranslationDataController.getTranslationData('footer', protocol);
      this.processData(response.data);
      this.host.requestUpdate();
    }
  }

  processData(jsonData) {
    this.linkData = jsonData;
  }

  async getTarget() {
    await this.getAuthStatus();
    if (this.authStatus === AuthStatus.SECURED) {
      try {
        const resp = await this.authService.getMemberInformation();
        this.memberInfo = resp;
        if (this.memberInfo?.aadvantageNumber !== undefined) {
          this.aadvantageNumber = this.memberInfo.aadvantageNumber;
        }
      } catch (err) {
        throw err;
      }
    }
    this.getTargetDetails();
  }
  

  // get login status from loyalty API
  async getAuthStatus() {
    await this.authService.getAuthStatus().then(resp => {
      this.authStatus = resp.status;
      this.loginStatus = LoginStatus[this.authStatus];
    }).catch(err => {
      const url = new URL(document.location.href);
      const allowedAADomains = [
        'www.aa.com',
        'iqa.qa.aa.com',
        'iqa2.qa.aa.com',
        'stage.aa.com'
      ];

      if (allowedAADomains.includes(url.hostname) || url.hostname.includes('american')) {
        this.authStatus = AuthStatus.GUEST;
        this.loginStatus = LoginStatus[this.authStatus];
      }

      console.log('authStatus error, ', err);
    });
  }

  async getTargetDetails() {
    await axios.get<ITargetDetails>(this.buildTargetedUrl()).then(resp => {
      this.targetDetails = resp.data;
      this.host.requestUpdate();
    }).catch(err => {
      console.log("", err);
    });
  }

  private buildTargetedUrl(): string {
    const url = new URL(document.location.href);
    const isHomePage = GlobalDataController._isHomePage() ? 'T' : 'F';
    const contentURL = `locale=${this.locale}&loginStatus=${this.loginStatus}&min=1&max=3&subType=FooterMessage1&isHomePage=${isHomePage}&slot=true&aaAdvNum=${this.aadvantageNumber}`;

    let urlToFetch = '';
    if (url.hostname === "localhost" || url.hostname.endsWith(".pages.github.io")) {
      // used for local testing
      urlToFetch = `${this.protocol}//aacom-qa-cluster-dal.us-south.containers.appdomain.cloud/tcs/v2/content/MarketingMessages?${contentURL}`;
    } else {
      urlToFetch = `${this.protocol}//${url.hostname}/targeted-content-service/v2/content/MarketingMessages?${contentURL}`;
    }
    return urlToFetch;
  } 

}
